import { useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import { Logo } from "../Logo";
import { Footer } from "./Footer";
import { buttonVariants } from "../ui/Button";
import { cn } from "../../lib/cn";
import { useAuth } from "../../lib/auth";

const NAV = [
  { href: "/#how", label: "How it works" },
  { href: "/exchange", label: "Exchange" },
  { href: "/#deploy", label: "Deploy" },
  { href: "/#features", label: "Platform" },
  { href: "/about", label: "About" },
  { href: "/contact", label: "Contact" },
];

export function PublicLayout() {
  const { user } = useAuth();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Dark header everywhere. At the top of the (dark) hero it's solid and
  // seamless; once scrolled over lighter content it becomes a floating dark
  // glass bar with blur + shadow.
  return (
    <div className="flex min-h-screen flex-col">
      <header
        className={cn(
          "sticky top-0 z-40 border-b transition-all duration-300",
          scrolled
            ? "border-white/10 bg-slate-950/70 shadow-lift backdrop-blur-xl"
            : "border-white/[0.06] bg-gradient-to-b from-slate-900 to-slate-950",
        )}
      >
        <div className="mx-auto flex h-[68px] max-w-6xl items-center justify-between px-6">
          <Link to="/" className="focus-ring rounded-xl" aria-label="Wise 2.0 home">
            <Logo light size={32} />
          </Link>

          <nav className="hidden items-center gap-8 text-sm font-medium text-slate-300 md:flex">
            {NAV.map((n) => (
              <a key={n.label} href={n.href} className="relative transition-colors hover:text-white">
                {n.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            {user ? (
              <Link to="/app" className={buttonVariants({ size: "sm" })}>Open app</Link>
            ) : (
              <>
                <Link
                  to="/login"
                  className="focus-ring hidden h-9 items-center rounded-xl px-3.5 text-sm font-semibold text-white/90 transition-colors hover:bg-white/10 sm:inline-flex"
                >
                  Sign in
                </Link>
                <Link to="/signup" className={buttonVariants({ size: "sm" })}>
                  Get started
                </Link>
              </>
            )}
          </div>
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
